import { CrownIcon, UserIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface AgentNodeIconProps {
  isEntryPoint: boolean
}

export const AgentNodeIcon = ({ isEntryPoint }: AgentNodeIconProps): ReactNode => (
  <div
    className={cn(
      'agent-node-icon flex size-8 shrink-0 items-center justify-center rounded-full',
      isEntryPoint ? 'bg-amber-100 text-amber-700' : 'bg-muted text-muted-foreground'
    )}
  >
    {isEntryPoint ? <CrownIcon className="size-4" /> : <UserIcon className="size-4" />}
  </div>
)

AgentNodeIcon.displayName = 'AgentNodeIcon'
